/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmTeasableCommon_CmArticleImpl_Fragment, CmTeasableCommon_CmAudioImpl_Fragment, CmTeasableCommon_CmChannelImpl_Fragment, CmTeasableCommon_CmCollectionImpl_Fragment, CmTeasableCommon_CmDownloadImpl_Fragment, CmTeasableCommon_CmDynamicListImpl_Fragment, CmTeasableCommon_CmExternalLinkImpl_Fragment, CmTeasableCommon_CmGalleryImpl_Fragment, CmTeasableCommon_CmhtmlImpl_Fragment, CmTeasableCommon_CmImageMapImpl_Fragment, CmTeasableCommon_CmInteractiveImpl_Fragment, CmTeasableCommon_CmLocTaxonomyImpl_Fragment, CmTeasableCommon_CmMediaImpl_Fragment, CmTeasableCommon_CmNavigationImpl_Fragment, CmTeasableCommon_CmPersonImpl_Fragment, CmTeasableCommon_CmPictureImpl_Fragment, CmTeasableCommon_CmPlaceholderImpl_Fragment, CmTeasableCommon_CmProductImpl_Fragment, CmTeasableCommon_CmQueryListImpl_Fragment, CmTeasableCommon_CmSelectionRulesImpl_Fragment, CmTeasableCommon_CmSpinnerImpl_Fragment, CmTeasableCommon_CmTaxonomyImpl_Fragment, CmTeasableCommon_CmTeasableImpl_Fragment, CmTeasableCommon_CmTeaserImpl_Fragment, CmTeasableCommon_CmVideoImpl_Fragment, CmTeasableCommon_CmVisualImpl_Fragment, CmTeasableCommon_FormEditorImpl_Fragment, CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment, CmTeasableCommon_SosAuthorImpl_Fragment, CmTeasableCommon_SosChartImpl_Fragment, CmTeasableCommon_SosContactImpl_Fragment, CmTeasableCommon_SosDonationCardImpl_Fragment, CmTeasableCommon_SosDonationCertificateImpl_Fragment, CmTeasableCommon_SosDonationFormImpl_Fragment, CmTeasableCommon_SosDonationProductImpl_Fragment, CmTeasableCommon_SosDonationProgressImpl_Fragment, CmTeasableCommon_SosDonationToolImpl_Fragment, CmTeasableCommon_SosEventImpl_Fragment, CmTeasableCommon_SosFilterTeaserImpl_Fragment, CmTeasableCommon_SosInternalLinkImpl_Fragment, CmTeasableCommon_SosJobTeaserImpl_Fragment, CmTeasableCommon_SosLocationImpl_Fragment, CmTeasableCommon_SosNewsImpl_Fragment, CmTeasableCommon_SosNotificationImpl_Fragment, CmTeasableCommon_SosOfferImpl_Fragment, CmTeasableCommon_SosOrderFormImpl_Fragment, CmTeasableCommon_SosOrganisationImpl_Fragment, CmTeasableCommon_SosOverlayImpl_Fragment, CmTeasableCommon_SosPressreleaseImpl_Fragment, CmTeasableCommon_SosPublicationImpl_Fragment, CmTeasableCommon_SosRedirectPageImpl_Fragment, CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment, CmTeasableCommon_SosSpecialTopicImpl_Fragment, CmTeasableCommon_SosTeaserImpl_Fragment, CmTeasableCommon_SosTextfragmentImpl_Fragment, CmTeasableCommon_SosTooltipImpl_Fragment, CmTeasableCommon_SosWimmelbildImpl_Fragment, CmTeasableCommon_ViewTypeHeroCollection_Fragment } from './CMTeasableCommon.fragment';
import { CmTaxonomy_CmLocTaxonomyImpl_Fragment, CmTaxonomy_CmTaxonomyImpl_Fragment, CmTaxonomy_SosLocationImpl_Fragment } from './CMTaxonomy.fragment';
import { CmTeasableDates_CmArticleImpl_Fragment, CmTeasableDates_CmAudioImpl_Fragment, CmTeasableDates_CmChannelImpl_Fragment, CmTeasableDates_CmCollectionImpl_Fragment, CmTeasableDates_CmDownloadImpl_Fragment, CmTeasableDates_CmDynamicListImpl_Fragment, CmTeasableDates_CmExternalLinkImpl_Fragment, CmTeasableDates_CmGalleryImpl_Fragment, CmTeasableDates_CmhtmlImpl_Fragment, CmTeasableDates_CmImageMapImpl_Fragment, CmTeasableDates_CmInteractiveImpl_Fragment, CmTeasableDates_CmLocTaxonomyImpl_Fragment, CmTeasableDates_CmMediaImpl_Fragment, CmTeasableDates_CmNavigationImpl_Fragment, CmTeasableDates_CmPersonImpl_Fragment, CmTeasableDates_CmPictureImpl_Fragment, CmTeasableDates_CmPlaceholderImpl_Fragment, CmTeasableDates_CmProductImpl_Fragment, CmTeasableDates_CmQueryListImpl_Fragment, CmTeasableDates_CmSelectionRulesImpl_Fragment, CmTeasableDates_CmSpinnerImpl_Fragment, CmTeasableDates_CmTaxonomyImpl_Fragment, CmTeasableDates_CmTeasableImpl_Fragment, CmTeasableDates_CmTeaserImpl_Fragment, CmTeasableDates_CmVideoImpl_Fragment, CmTeasableDates_CmVisualImpl_Fragment, CmTeasableDates_FormEditorImpl_Fragment, CmTeasableDates_SosAmountIncreaseFormImpl_Fragment, CmTeasableDates_SosAuthorImpl_Fragment, CmTeasableDates_SosChartImpl_Fragment, CmTeasableDates_SosContactImpl_Fragment, CmTeasableDates_SosDonationCardImpl_Fragment, CmTeasableDates_SosDonationCertificateImpl_Fragment, CmTeasableDates_SosDonationFormImpl_Fragment, CmTeasableDates_SosDonationProductImpl_Fragment, CmTeasableDates_SosDonationProgressImpl_Fragment, CmTeasableDates_SosDonationToolImpl_Fragment, CmTeasableDates_SosEventImpl_Fragment, CmTeasableDates_SosFilterTeaserImpl_Fragment, CmTeasableDates_SosInternalLinkImpl_Fragment, CmTeasableDates_SosJobTeaserImpl_Fragment, CmTeasableDates_SosLocationImpl_Fragment, CmTeasableDates_SosNewsImpl_Fragment, CmTeasableDates_SosNotificationImpl_Fragment, CmTeasableDates_SosOfferImpl_Fragment, CmTeasableDates_SosOrderFormImpl_Fragment, CmTeasableDates_SosOrganisationImpl_Fragment, CmTeasableDates_SosOverlayImpl_Fragment, CmTeasableDates_SosPressreleaseImpl_Fragment, CmTeasableDates_SosPublicationImpl_Fragment, CmTeasableDates_SosRedirectPageImpl_Fragment, CmTeasableDates_SosSpecialTopicCategoryImpl_Fragment, CmTeasableDates_SosSpecialTopicImpl_Fragment, CmTeasableDates_SosTeaserImpl_Fragment, CmTeasableDates_SosTextfragmentImpl_Fragment, CmTeasableDates_SosTooltipImpl_Fragment, CmTeasableDates_SosWimmelbildImpl_Fragment, CmTeasableDates_ViewTypeHeroCollection_Fragment } from './CMTeasableDates.fragment';
import { CmTeasableTeaserIcon_CmArticleImpl_Fragment, CmTeasableTeaserIcon_CmAudioImpl_Fragment, CmTeasableTeaserIcon_CmChannelImpl_Fragment, CmTeasableTeaserIcon_CmCollectionImpl_Fragment, CmTeasableTeaserIcon_CmDownloadImpl_Fragment, CmTeasableTeaserIcon_CmDynamicListImpl_Fragment, CmTeasableTeaserIcon_CmExternalLinkImpl_Fragment, CmTeasableTeaserIcon_CmGalleryImpl_Fragment, CmTeasableTeaserIcon_CmhtmlImpl_Fragment, CmTeasableTeaserIcon_CmImageMapImpl_Fragment, CmTeasableTeaserIcon_CmInteractiveImpl_Fragment, CmTeasableTeaserIcon_CmLocTaxonomyImpl_Fragment, CmTeasableTeaserIcon_CmMediaImpl_Fragment, CmTeasableTeaserIcon_CmNavigationImpl_Fragment, CmTeasableTeaserIcon_CmPersonImpl_Fragment, CmTeasableTeaserIcon_CmPictureImpl_Fragment, CmTeasableTeaserIcon_CmPlaceholderImpl_Fragment, CmTeasableTeaserIcon_CmProductImpl_Fragment, CmTeasableTeaserIcon_CmQueryListImpl_Fragment, CmTeasableTeaserIcon_CmSelectionRulesImpl_Fragment, CmTeasableTeaserIcon_CmSpinnerImpl_Fragment, CmTeasableTeaserIcon_CmTaxonomyImpl_Fragment, CmTeasableTeaserIcon_CmTeasableImpl_Fragment, CmTeasableTeaserIcon_CmTeaserImpl_Fragment, CmTeasableTeaserIcon_CmVideoImpl_Fragment, CmTeasableTeaserIcon_CmVisualImpl_Fragment, CmTeasableTeaserIcon_FormEditorImpl_Fragment, CmTeasableTeaserIcon_SosAmountIncreaseFormImpl_Fragment, CmTeasableTeaserIcon_SosAuthorImpl_Fragment, CmTeasableTeaserIcon_SosChartImpl_Fragment, CmTeasableTeaserIcon_SosContactImpl_Fragment, CmTeasableTeaserIcon_SosDonationCardImpl_Fragment, CmTeasableTeaserIcon_SosDonationCertificateImpl_Fragment, CmTeasableTeaserIcon_SosDonationFormImpl_Fragment, CmTeasableTeaserIcon_SosDonationProductImpl_Fragment, CmTeasableTeaserIcon_SosDonationProgressImpl_Fragment, CmTeasableTeaserIcon_SosDonationToolImpl_Fragment, CmTeasableTeaserIcon_SosEventImpl_Fragment, CmTeasableTeaserIcon_SosFilterTeaserImpl_Fragment, CmTeasableTeaserIcon_SosInternalLinkImpl_Fragment, CmTeasableTeaserIcon_SosJobTeaserImpl_Fragment, CmTeasableTeaserIcon_SosLocationImpl_Fragment, CmTeasableTeaserIcon_SosNewsImpl_Fragment, CmTeasableTeaserIcon_SosNotificationImpl_Fragment, CmTeasableTeaserIcon_SosOfferImpl_Fragment, CmTeasableTeaserIcon_SosOrderFormImpl_Fragment, CmTeasableTeaserIcon_SosOrganisationImpl_Fragment, CmTeasableTeaserIcon_SosOverlayImpl_Fragment, CmTeasableTeaserIcon_SosPressreleaseImpl_Fragment, CmTeasableTeaserIcon_SosPublicationImpl_Fragment, CmTeasableTeaserIcon_SosRedirectPageImpl_Fragment, CmTeasableTeaserIcon_SosSpecialTopicCategoryImpl_Fragment, CmTeasableTeaserIcon_SosSpecialTopicImpl_Fragment, CmTeasableTeaserIcon_SosTeaserImpl_Fragment, CmTeasableTeaserIcon_SosTextfragmentImpl_Fragment, CmTeasableTeaserIcon_SosTooltipImpl_Fragment, CmTeasableTeaserIcon_SosWimmelbildImpl_Fragment, CmTeasableTeaserIcon_ViewTypeHeroCollection_Fragment } from './CMTeasableTeaserIcon.fragment';
import { CmTeasableLayout_CmArticleImpl_Fragment, CmTeasableLayout_CmAudioImpl_Fragment, CmTeasableLayout_CmChannelImpl_Fragment, CmTeasableLayout_CmCollectionImpl_Fragment, CmTeasableLayout_CmDownloadImpl_Fragment, CmTeasableLayout_CmDynamicListImpl_Fragment, CmTeasableLayout_CmExternalLinkImpl_Fragment, CmTeasableLayout_CmGalleryImpl_Fragment, CmTeasableLayout_CmhtmlImpl_Fragment, CmTeasableLayout_CmImageMapImpl_Fragment, CmTeasableLayout_CmInteractiveImpl_Fragment, CmTeasableLayout_CmLocTaxonomyImpl_Fragment, CmTeasableLayout_CmMediaImpl_Fragment, CmTeasableLayout_CmNavigationImpl_Fragment, CmTeasableLayout_CmPersonImpl_Fragment, CmTeasableLayout_CmPictureImpl_Fragment, CmTeasableLayout_CmPlaceholderImpl_Fragment, CmTeasableLayout_CmProductImpl_Fragment, CmTeasableLayout_CmQueryListImpl_Fragment, CmTeasableLayout_CmSelectionRulesImpl_Fragment, CmTeasableLayout_CmSpinnerImpl_Fragment, CmTeasableLayout_CmTaxonomyImpl_Fragment, CmTeasableLayout_CmTeasableImpl_Fragment, CmTeasableLayout_CmTeaserImpl_Fragment, CmTeasableLayout_CmVideoImpl_Fragment, CmTeasableLayout_CmVisualImpl_Fragment, CmTeasableLayout_FormEditorImpl_Fragment, CmTeasableLayout_SosAmountIncreaseFormImpl_Fragment, CmTeasableLayout_SosAuthorImpl_Fragment, CmTeasableLayout_SosChartImpl_Fragment, CmTeasableLayout_SosContactImpl_Fragment, CmTeasableLayout_SosDonationCardImpl_Fragment, CmTeasableLayout_SosDonationCertificateImpl_Fragment, CmTeasableLayout_SosDonationFormImpl_Fragment, CmTeasableLayout_SosDonationProductImpl_Fragment, CmTeasableLayout_SosDonationProgressImpl_Fragment, CmTeasableLayout_SosDonationToolImpl_Fragment, CmTeasableLayout_SosEventImpl_Fragment, CmTeasableLayout_SosFilterTeaserImpl_Fragment, CmTeasableLayout_SosInternalLinkImpl_Fragment, CmTeasableLayout_SosJobTeaserImpl_Fragment, CmTeasableLayout_SosLocationImpl_Fragment, CmTeasableLayout_SosNewsImpl_Fragment, CmTeasableLayout_SosNotificationImpl_Fragment, CmTeasableLayout_SosOfferImpl_Fragment, CmTeasableLayout_SosOrderFormImpl_Fragment, CmTeasableLayout_SosOrganisationImpl_Fragment, CmTeasableLayout_SosOverlayImpl_Fragment, CmTeasableLayout_SosPressreleaseImpl_Fragment, CmTeasableLayout_SosPublicationImpl_Fragment, CmTeasableLayout_SosRedirectPageImpl_Fragment, CmTeasableLayout_SosSpecialTopicCategoryImpl_Fragment, CmTeasableLayout_SosSpecialTopicImpl_Fragment, CmTeasableLayout_SosTeaserImpl_Fragment, CmTeasableLayout_SosTextfragmentImpl_Fragment, CmTeasableLayout_SosTooltipImpl_Fragment, CmTeasableLayout_SosWimmelbildImpl_Fragment, CmTeasableLayout_ViewTypeHeroCollection_Fragment } from './CMTeasableLayout.fragment';
import { CmTeasableTeaserTarget_CmArticleImpl_Fragment, CmTeasableTeaserTarget_CmAudioImpl_Fragment, CmTeasableTeaserTarget_CmChannelImpl_Fragment, CmTeasableTeaserTarget_CmCollectionImpl_Fragment, CmTeasableTeaserTarget_CmDownloadImpl_Fragment, CmTeasableTeaserTarget_CmDynamicListImpl_Fragment, CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment, CmTeasableTeaserTarget_CmGalleryImpl_Fragment, CmTeasableTeaserTarget_CmhtmlImpl_Fragment, CmTeasableTeaserTarget_CmImageMapImpl_Fragment, CmTeasableTeaserTarget_CmInteractiveImpl_Fragment, CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment, CmTeasableTeaserTarget_CmMediaImpl_Fragment, CmTeasableTeaserTarget_CmNavigationImpl_Fragment, CmTeasableTeaserTarget_CmPersonImpl_Fragment, CmTeasableTeaserTarget_CmPictureImpl_Fragment, CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment, CmTeasableTeaserTarget_CmProductImpl_Fragment, CmTeasableTeaserTarget_CmQueryListImpl_Fragment, CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment, CmTeasableTeaserTarget_CmSpinnerImpl_Fragment, CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment, CmTeasableTeaserTarget_CmTeasableImpl_Fragment, CmTeasableTeaserTarget_CmTeaserImpl_Fragment, CmTeasableTeaserTarget_CmVideoImpl_Fragment, CmTeasableTeaserTarget_CmVisualImpl_Fragment, CmTeasableTeaserTarget_FormEditorImpl_Fragment, CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment, CmTeasableTeaserTarget_SosAuthorImpl_Fragment, CmTeasableTeaserTarget_SosChartImpl_Fragment, CmTeasableTeaserTarget_SosContactImpl_Fragment, CmTeasableTeaserTarget_SosDonationCardImpl_Fragment, CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment, CmTeasableTeaserTarget_SosDonationFormImpl_Fragment, CmTeasableTeaserTarget_SosDonationProductImpl_Fragment, CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment, CmTeasableTeaserTarget_SosDonationToolImpl_Fragment, CmTeasableTeaserTarget_SosEventImpl_Fragment, CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment, CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment, CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment, CmTeasableTeaserTarget_SosLocationImpl_Fragment, CmTeasableTeaserTarget_SosNewsImpl_Fragment, CmTeasableTeaserTarget_SosNotificationImpl_Fragment, CmTeasableTeaserTarget_SosOfferImpl_Fragment, CmTeasableTeaserTarget_SosOrderFormImpl_Fragment, CmTeasableTeaserTarget_SosOrganisationImpl_Fragment, CmTeasableTeaserTarget_SosOverlayImpl_Fragment, CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment, CmTeasableTeaserTarget_SosPublicationImpl_Fragment, CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment, CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment, CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment, CmTeasableTeaserTarget_SosTeaserImpl_Fragment, CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment, CmTeasableTeaserTarget_SosTooltipImpl_Fragment, CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment, CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment } from './CMTeasebleTeaserTarget.fragment';
import { gql } from '@apollo/client';
import { CmTeasableCommonFragmentDoc } from './CMTeasableCommon.fragment';
import { CmTaxonomyFragmentDoc } from './CMTaxonomy.fragment';
import { CmTeasableDatesFragmentDoc } from './CMTeasableDates.fragment';
import { CmTeasableTeaserIconFragmentDoc } from './CMTeasableTeaserIcon.fragment';
import { CmTeasableLayoutFragmentDoc } from './CMTeasableLayout.fragment';
import { CmTeasableTeaserTargetFragmentDoc } from './CMTeasebleTeaserTarget.fragment';
export type CmTeasable_CmArticleImpl_Fragment = (
  { __typename?: 'CMArticleImpl' }
  & CmTeasableCommon_CmArticleImpl_Fragment
  & CmTeasableDates_CmArticleImpl_Fragment
  & CmTeasableTeaserIcon_CmArticleImpl_Fragment
  & CmTeasableLayout_CmArticleImpl_Fragment
  & CmTeasableTeaserTarget_CmArticleImpl_Fragment
);

export type CmTeasable_CmAudioImpl_Fragment = (
  { __typename?: 'CMAudioImpl' }
  & CmTeasableCommon_CmAudioImpl_Fragment
  & CmTeasableDates_CmAudioImpl_Fragment
  & CmTeasableTeaserIcon_CmAudioImpl_Fragment
  & CmTeasableLayout_CmAudioImpl_Fragment
  & CmTeasableTeaserTarget_CmAudioImpl_Fragment
);

export type CmTeasable_CmChannelImpl_Fragment = (
  { __typename?: 'CMChannelImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmChannelImpl_Fragment
  & CmTeasableDates_CmChannelImpl_Fragment
  & CmTeasableTeaserIcon_CmChannelImpl_Fragment
  & CmTeasableLayout_CmChannelImpl_Fragment
  & CmTeasableTeaserTarget_CmChannelImpl_Fragment
);

export type CmTeasable_CmCollectionImpl_Fragment = (
  { __typename?: 'CMCollectionImpl' }
  & CmTeasableCommon_CmCollectionImpl_Fragment
  & CmTeasableDates_CmCollectionImpl_Fragment
  & CmTeasableTeaserIcon_CmCollectionImpl_Fragment
  & CmTeasableLayout_CmCollectionImpl_Fragment
  & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
);

export type CmTeasable_CmDownloadImpl_Fragment = (
  { __typename?: 'CMDownloadImpl' }
  & CmTeasableCommon_CmDownloadImpl_Fragment
  & CmTeasableDates_CmDownloadImpl_Fragment
  & CmTeasableTeaserIcon_CmDownloadImpl_Fragment
  & CmTeasableLayout_CmDownloadImpl_Fragment
  & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
);

export type CmTeasable_CmDynamicListImpl_Fragment = (
  { __typename?: 'CMDynamicListImpl' }
  & CmTeasableCommon_CmDynamicListImpl_Fragment
  & CmTeasableDates_CmDynamicListImpl_Fragment
  & CmTeasableTeaserIcon_CmDynamicListImpl_Fragment
  & CmTeasableLayout_CmDynamicListImpl_Fragment
  & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
);

export type CmTeasable_CmExternalLinkImpl_Fragment = (
  { __typename?: 'CMExternalLinkImpl' }
  & CmTeasableCommon_CmExternalLinkImpl_Fragment
  & CmTeasableDates_CmExternalLinkImpl_Fragment
  & CmTeasableTeaserIcon_CmExternalLinkImpl_Fragment
  & CmTeasableLayout_CmExternalLinkImpl_Fragment
  & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
);

export type CmTeasable_CmGalleryImpl_Fragment = (
  { __typename?: 'CMGalleryImpl' }
  & CmTeasableCommon_CmGalleryImpl_Fragment
  & CmTeasableDates_CmGalleryImpl_Fragment
  & CmTeasableTeaserIcon_CmGalleryImpl_Fragment
  & CmTeasableLayout_CmGalleryImpl_Fragment
  & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
);

export type CmTeasable_CmhtmlImpl_Fragment = (
  { __typename?: 'CMHTMLImpl' }
  & CmTeasableCommon_CmhtmlImpl_Fragment
  & CmTeasableDates_CmhtmlImpl_Fragment
  & CmTeasableTeaserIcon_CmhtmlImpl_Fragment
  & CmTeasableLayout_CmhtmlImpl_Fragment
  & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
);

export type CmTeasable_CmImageMapImpl_Fragment = (
  { __typename?: 'CMImageMapImpl' }
  & CmTeasableCommon_CmImageMapImpl_Fragment
  & CmTeasableDates_CmImageMapImpl_Fragment
  & CmTeasableTeaserIcon_CmImageMapImpl_Fragment
  & CmTeasableLayout_CmImageMapImpl_Fragment
  & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
);

export type CmTeasable_CmInteractiveImpl_Fragment = (
  { __typename?: 'CMInteractiveImpl' }
  & CmTeasableCommon_CmInteractiveImpl_Fragment
  & CmTeasableDates_CmInteractiveImpl_Fragment
  & CmTeasableTeaserIcon_CmInteractiveImpl_Fragment
  & CmTeasableLayout_CmInteractiveImpl_Fragment
  & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
);

export type CmTeasable_CmLocTaxonomyImpl_Fragment = (
  { __typename?: 'CMLocTaxonomyImpl' }
  & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
  & CmTeasableDates_CmLocTaxonomyImpl_Fragment
  & CmTeasableTeaserIcon_CmLocTaxonomyImpl_Fragment
  & CmTeasableLayout_CmLocTaxonomyImpl_Fragment
  & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
);

export type CmTeasable_CmMediaImpl_Fragment = (
  { __typename?: 'CMMediaImpl' }
  & CmTeasableCommon_CmMediaImpl_Fragment
  & CmTeasableDates_CmMediaImpl_Fragment
  & CmTeasableTeaserIcon_CmMediaImpl_Fragment
  & CmTeasableLayout_CmMediaImpl_Fragment
  & CmTeasableTeaserTarget_CmMediaImpl_Fragment
);

export type CmTeasable_CmNavigationImpl_Fragment = (
  { __typename?: 'CMNavigationImpl' }
  & CmTeasableCommon_CmNavigationImpl_Fragment
  & CmTeasableDates_CmNavigationImpl_Fragment
  & CmTeasableTeaserIcon_CmNavigationImpl_Fragment
  & CmTeasableLayout_CmNavigationImpl_Fragment
  & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
);

export type CmTeasable_CmPersonImpl_Fragment = (
  { __typename?: 'CMPersonImpl' }
  & CmTeasableCommon_CmPersonImpl_Fragment
  & CmTeasableDates_CmPersonImpl_Fragment
  & CmTeasableTeaserIcon_CmPersonImpl_Fragment
  & CmTeasableLayout_CmPersonImpl_Fragment
  & CmTeasableTeaserTarget_CmPersonImpl_Fragment
);

export type CmTeasable_CmPictureImpl_Fragment = (
  { __typename?: 'CMPictureImpl' }
  & CmTeasableCommon_CmPictureImpl_Fragment
  & CmTeasableDates_CmPictureImpl_Fragment
  & CmTeasableTeaserIcon_CmPictureImpl_Fragment
  & CmTeasableLayout_CmPictureImpl_Fragment
  & CmTeasableTeaserTarget_CmPictureImpl_Fragment
);

export type CmTeasable_CmPlaceholderImpl_Fragment = (
  { __typename?: 'CMPlaceholderImpl' }
  & CmTeasableCommon_CmPlaceholderImpl_Fragment
  & CmTeasableDates_CmPlaceholderImpl_Fragment
  & CmTeasableTeaserIcon_CmPlaceholderImpl_Fragment
  & CmTeasableLayout_CmPlaceholderImpl_Fragment
  & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
);

export type CmTeasable_CmProductImpl_Fragment = (
  { __typename?: 'CMProductImpl' }
  & CmTeasableCommon_CmProductImpl_Fragment
  & CmTeasableDates_CmProductImpl_Fragment
  & CmTeasableTeaserIcon_CmProductImpl_Fragment
  & CmTeasableLayout_CmProductImpl_Fragment
  & CmTeasableTeaserTarget_CmProductImpl_Fragment
);

export type CmTeasable_CmQueryListImpl_Fragment = (
  { __typename?: 'CMQueryListImpl' }
  & CmTeasableCommon_CmQueryListImpl_Fragment
  & CmTeasableDates_CmQueryListImpl_Fragment
  & CmTeasableTeaserIcon_CmQueryListImpl_Fragment
  & CmTeasableLayout_CmQueryListImpl_Fragment
  & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
);

export type CmTeasable_CmSelectionRulesImpl_Fragment = (
  { __typename?: 'CMSelectionRulesImpl' }
  & CmTeasableCommon_CmSelectionRulesImpl_Fragment
  & CmTeasableDates_CmSelectionRulesImpl_Fragment
  & CmTeasableTeaserIcon_CmSelectionRulesImpl_Fragment
  & CmTeasableLayout_CmSelectionRulesImpl_Fragment
  & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
);

export type CmTeasable_CmSpinnerImpl_Fragment = (
  { __typename?: 'CMSpinnerImpl' }
  & CmTeasableCommon_CmSpinnerImpl_Fragment
  & CmTeasableDates_CmSpinnerImpl_Fragment
  & CmTeasableTeaserIcon_CmSpinnerImpl_Fragment
  & CmTeasableLayout_CmSpinnerImpl_Fragment
  & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
);

export type CmTeasable_CmTaxonomyImpl_Fragment = (
  { __typename?: 'CMTaxonomyImpl' }
  & CmTeasableCommon_CmTaxonomyImpl_Fragment
  & CmTeasableDates_CmTaxonomyImpl_Fragment
  & CmTeasableTeaserIcon_CmTaxonomyImpl_Fragment
  & CmTeasableLayout_CmTaxonomyImpl_Fragment
  & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
);

export type CmTeasable_CmTeasableImpl_Fragment = (
  { __typename?: 'CMTeasableImpl' }
  & CmTeasableCommon_CmTeasableImpl_Fragment
  & CmTeasableDates_CmTeasableImpl_Fragment
  & CmTeasableTeaserIcon_CmTeasableImpl_Fragment
  & CmTeasableLayout_CmTeasableImpl_Fragment
  & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
);

export type CmTeasable_CmTeaserImpl_Fragment = (
  { __typename?: 'CMTeaserImpl' }
  & CmTeasableCommon_CmTeaserImpl_Fragment
  & CmTeasableDates_CmTeaserImpl_Fragment
  & CmTeasableTeaserIcon_CmTeaserImpl_Fragment
  & CmTeasableLayout_CmTeaserImpl_Fragment
  & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
);

export type CmTeasable_CmVideoImpl_Fragment = (
  { __typename?: 'CMVideoImpl' }
  & CmTeasableCommon_CmVideoImpl_Fragment
  & CmTeasableDates_CmVideoImpl_Fragment
  & CmTeasableTeaserIcon_CmVideoImpl_Fragment
  & CmTeasableLayout_CmVideoImpl_Fragment
  & CmTeasableTeaserTarget_CmVideoImpl_Fragment
);

export type CmTeasable_CmVisualImpl_Fragment = (
  { __typename?: 'CMVisualImpl' }
  & CmTeasableCommon_CmVisualImpl_Fragment
  & CmTeasableDates_CmVisualImpl_Fragment
  & CmTeasableTeaserIcon_CmVisualImpl_Fragment
  & CmTeasableLayout_CmVisualImpl_Fragment
  & CmTeasableTeaserTarget_CmVisualImpl_Fragment
);

export type CmTeasable_FormEditorImpl_Fragment = (
  { __typename?: 'FormEditorImpl' }
  & CmTeasableCommon_FormEditorImpl_Fragment
  & CmTeasableDates_FormEditorImpl_Fragment
  & CmTeasableTeaserIcon_FormEditorImpl_Fragment
  & CmTeasableLayout_FormEditorImpl_Fragment
  & CmTeasableTeaserTarget_FormEditorImpl_Fragment
);

export type CmTeasable_SosAmountIncreaseFormImpl_Fragment = (
  { __typename?: 'SOSAmountIncreaseFormImpl' }
  & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
  & CmTeasableDates_SosAmountIncreaseFormImpl_Fragment
  & CmTeasableTeaserIcon_SosAmountIncreaseFormImpl_Fragment
  & CmTeasableLayout_SosAmountIncreaseFormImpl_Fragment
  & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
);

export type CmTeasable_SosAuthorImpl_Fragment = (
  { __typename?: 'SOSAuthorImpl' }
  & CmTeasableCommon_SosAuthorImpl_Fragment
  & CmTeasableDates_SosAuthorImpl_Fragment
  & CmTeasableTeaserIcon_SosAuthorImpl_Fragment
  & CmTeasableLayout_SosAuthorImpl_Fragment
  & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
);

export type CmTeasable_SosChartImpl_Fragment = (
  { __typename?: 'SOSChartImpl' }
  & CmTeasableCommon_SosChartImpl_Fragment
  & CmTeasableDates_SosChartImpl_Fragment
  & CmTeasableTeaserIcon_SosChartImpl_Fragment
  & CmTeasableLayout_SosChartImpl_Fragment
  & CmTeasableTeaserTarget_SosChartImpl_Fragment
);

export type CmTeasable_SosContactImpl_Fragment = (
  { __typename?: 'SOSContactImpl' }
  & CmTeasableCommon_SosContactImpl_Fragment
  & CmTeasableDates_SosContactImpl_Fragment
  & CmTeasableTeaserIcon_SosContactImpl_Fragment
  & CmTeasableLayout_SosContactImpl_Fragment
  & CmTeasableTeaserTarget_SosContactImpl_Fragment
);

export type CmTeasable_SosDonationCardImpl_Fragment = (
  { __typename?: 'SOSDonationCardImpl' }
  & CmTeasableCommon_SosDonationCardImpl_Fragment
  & CmTeasableDates_SosDonationCardImpl_Fragment
  & CmTeasableTeaserIcon_SosDonationCardImpl_Fragment
  & CmTeasableLayout_SosDonationCardImpl_Fragment
  & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
);

export type CmTeasable_SosDonationCertificateImpl_Fragment = (
  { __typename?: 'SOSDonationCertificateImpl' }
  & CmTeasableCommon_SosDonationCertificateImpl_Fragment
  & CmTeasableDates_SosDonationCertificateImpl_Fragment
  & CmTeasableTeaserIcon_SosDonationCertificateImpl_Fragment
  & CmTeasableLayout_SosDonationCertificateImpl_Fragment
  & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
);

export type CmTeasable_SosDonationFormImpl_Fragment = (
  { __typename?: 'SOSDonationFormImpl' }
  & CmTeasableCommon_SosDonationFormImpl_Fragment
  & CmTeasableDates_SosDonationFormImpl_Fragment
  & CmTeasableTeaserIcon_SosDonationFormImpl_Fragment
  & CmTeasableLayout_SosDonationFormImpl_Fragment
  & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
);

export type CmTeasable_SosDonationProductImpl_Fragment = (
  { __typename?: 'SOSDonationProductImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosDonationProductImpl_Fragment
  & CmTeasableDates_SosDonationProductImpl_Fragment
  & CmTeasableTeaserIcon_SosDonationProductImpl_Fragment
  & CmTeasableLayout_SosDonationProductImpl_Fragment
  & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
);

export type CmTeasable_SosDonationProgressImpl_Fragment = (
  { __typename?: 'SOSDonationProgressImpl' }
  & CmTeasableCommon_SosDonationProgressImpl_Fragment
  & CmTeasableDates_SosDonationProgressImpl_Fragment
  & CmTeasableTeaserIcon_SosDonationProgressImpl_Fragment
  & CmTeasableLayout_SosDonationProgressImpl_Fragment
  & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
);

export type CmTeasable_SosDonationToolImpl_Fragment = (
  { __typename?: 'SOSDonationToolImpl' }
  & CmTeasableCommon_SosDonationToolImpl_Fragment
  & CmTeasableDates_SosDonationToolImpl_Fragment
  & CmTeasableTeaserIcon_SosDonationToolImpl_Fragment
  & CmTeasableLayout_SosDonationToolImpl_Fragment
  & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
);

export type CmTeasable_SosEventImpl_Fragment = (
  { __typename?: 'SOSEventImpl' }
  & CmTeasableCommon_SosEventImpl_Fragment
  & CmTeasableDates_SosEventImpl_Fragment
  & CmTeasableTeaserIcon_SosEventImpl_Fragment
  & CmTeasableLayout_SosEventImpl_Fragment
  & CmTeasableTeaserTarget_SosEventImpl_Fragment
);

export type CmTeasable_SosFilterTeaserImpl_Fragment = (
  { __typename?: 'SOSFilterTeaserImpl' }
  & CmTeasableCommon_SosFilterTeaserImpl_Fragment
  & CmTeasableDates_SosFilterTeaserImpl_Fragment
  & CmTeasableTeaserIcon_SosFilterTeaserImpl_Fragment
  & CmTeasableLayout_SosFilterTeaserImpl_Fragment
  & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
);

export type CmTeasable_SosInternalLinkImpl_Fragment = (
  { __typename?: 'SOSInternalLinkImpl' }
  & CmTeasableCommon_SosInternalLinkImpl_Fragment
  & CmTeasableDates_SosInternalLinkImpl_Fragment
  & CmTeasableTeaserIcon_SosInternalLinkImpl_Fragment
  & CmTeasableLayout_SosInternalLinkImpl_Fragment
  & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
);

export type CmTeasable_SosJobTeaserImpl_Fragment = (
  { __typename?: 'SOSJobTeaserImpl' }
  & CmTeasableCommon_SosJobTeaserImpl_Fragment
  & CmTeasableDates_SosJobTeaserImpl_Fragment
  & CmTeasableTeaserIcon_SosJobTeaserImpl_Fragment
  & CmTeasableLayout_SosJobTeaserImpl_Fragment
  & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
);

export type CmTeasable_SosLocationImpl_Fragment = (
  { __typename?: 'SOSLocationImpl' }
  & CmTeasableCommon_SosLocationImpl_Fragment
  & CmTeasableDates_SosLocationImpl_Fragment
  & CmTeasableTeaserIcon_SosLocationImpl_Fragment
  & CmTeasableLayout_SosLocationImpl_Fragment
  & CmTeasableTeaserTarget_SosLocationImpl_Fragment
);

export type CmTeasable_SosNewsImpl_Fragment = (
  { __typename?: 'SOSNewsImpl' }
  & CmTeasableCommon_SosNewsImpl_Fragment
  & CmTeasableDates_SosNewsImpl_Fragment
  & CmTeasableTeaserIcon_SosNewsImpl_Fragment
  & CmTeasableLayout_SosNewsImpl_Fragment
  & CmTeasableTeaserTarget_SosNewsImpl_Fragment
);

export type CmTeasable_SosNotificationImpl_Fragment = (
  { __typename?: 'SOSNotificationImpl' }
  & CmTeasableCommon_SosNotificationImpl_Fragment
  & CmTeasableDates_SosNotificationImpl_Fragment
  & CmTeasableTeaserIcon_SosNotificationImpl_Fragment
  & CmTeasableLayout_SosNotificationImpl_Fragment
  & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
);

export type CmTeasable_SosOfferImpl_Fragment = (
  { __typename?: 'SOSOfferImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosOfferImpl_Fragment
  & CmTeasableDates_SosOfferImpl_Fragment
  & CmTeasableTeaserIcon_SosOfferImpl_Fragment
  & CmTeasableLayout_SosOfferImpl_Fragment
  & CmTeasableTeaserTarget_SosOfferImpl_Fragment
);

export type CmTeasable_SosOrderFormImpl_Fragment = (
  { __typename?: 'SOSOrderFormImpl' }
  & CmTeasableCommon_SosOrderFormImpl_Fragment
  & CmTeasableDates_SosOrderFormImpl_Fragment
  & CmTeasableTeaserIcon_SosOrderFormImpl_Fragment
  & CmTeasableLayout_SosOrderFormImpl_Fragment
  & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
);

export type CmTeasable_SosOrganisationImpl_Fragment = (
  { __typename?: 'SOSOrganisationImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosOrganisationImpl_Fragment
  & CmTeasableDates_SosOrganisationImpl_Fragment
  & CmTeasableTeaserIcon_SosOrganisationImpl_Fragment
  & CmTeasableLayout_SosOrganisationImpl_Fragment
  & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
);

export type CmTeasable_SosOverlayImpl_Fragment = (
  { __typename?: 'SOSOverlayImpl' }
  & CmTeasableCommon_SosOverlayImpl_Fragment
  & CmTeasableDates_SosOverlayImpl_Fragment
  & CmTeasableTeaserIcon_SosOverlayImpl_Fragment
  & CmTeasableLayout_SosOverlayImpl_Fragment
  & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
);

export type CmTeasable_SosPressreleaseImpl_Fragment = (
  { __typename?: 'SOSPressreleaseImpl' }
  & CmTeasableCommon_SosPressreleaseImpl_Fragment
  & CmTeasableDates_SosPressreleaseImpl_Fragment
  & CmTeasableTeaserIcon_SosPressreleaseImpl_Fragment
  & CmTeasableLayout_SosPressreleaseImpl_Fragment
  & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
);

export type CmTeasable_SosPublicationImpl_Fragment = (
  { __typename?: 'SOSPublicationImpl' }
  & CmTeasableCommon_SosPublicationImpl_Fragment
  & CmTeasableDates_SosPublicationImpl_Fragment
  & CmTeasableTeaserIcon_SosPublicationImpl_Fragment
  & CmTeasableLayout_SosPublicationImpl_Fragment
  & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
);

export type CmTeasable_SosRedirectPageImpl_Fragment = (
  { __typename?: 'SOSRedirectPageImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosRedirectPageImpl_Fragment
  & CmTeasableDates_SosRedirectPageImpl_Fragment
  & CmTeasableTeaserIcon_SosRedirectPageImpl_Fragment
  & CmTeasableLayout_SosRedirectPageImpl_Fragment
  & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
);

export type CmTeasable_SosSpecialTopicCategoryImpl_Fragment = (
  { __typename?: 'SOSSpecialTopicCategoryImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
  & CmTeasableDates_SosSpecialTopicCategoryImpl_Fragment
  & CmTeasableTeaserIcon_SosSpecialTopicCategoryImpl_Fragment
  & CmTeasableLayout_SosSpecialTopicCategoryImpl_Fragment
  & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
);

export type CmTeasable_SosSpecialTopicImpl_Fragment = (
  { __typename?: 'SOSSpecialTopicImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosSpecialTopicImpl_Fragment
  & CmTeasableDates_SosSpecialTopicImpl_Fragment
  & CmTeasableTeaserIcon_SosSpecialTopicImpl_Fragment
  & CmTeasableLayout_SosSpecialTopicImpl_Fragment
  & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
);

export type CmTeasable_SosTeaserImpl_Fragment = (
  { __typename?: 'SOSTeaserImpl' }
  & CmTeasableCommon_SosTeaserImpl_Fragment
  & CmTeasableDates_SosTeaserImpl_Fragment
  & CmTeasableTeaserIcon_SosTeaserImpl_Fragment
  & CmTeasableLayout_SosTeaserImpl_Fragment
  & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
);

export type CmTeasable_SosTextfragmentImpl_Fragment = (
  { __typename?: 'SOSTextfragmentImpl' }
  & CmTeasableCommon_SosTextfragmentImpl_Fragment
  & CmTeasableDates_SosTextfragmentImpl_Fragment
  & CmTeasableTeaserIcon_SosTextfragmentImpl_Fragment
  & CmTeasableLayout_SosTextfragmentImpl_Fragment
  & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
);

export type CmTeasable_SosTooltipImpl_Fragment = (
  { __typename?: 'SOSTooltipImpl' }
  & CmTeasableCommon_SosTooltipImpl_Fragment
  & CmTeasableDates_SosTooltipImpl_Fragment
  & CmTeasableTeaserIcon_SosTooltipImpl_Fragment
  & CmTeasableLayout_SosTooltipImpl_Fragment
  & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
);

export type CmTeasable_SosWimmelbildImpl_Fragment = (
  { __typename?: 'SOSWimmelbildImpl', specialTopicTaxonomy?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosWimmelbildImpl_Fragment
  & CmTeasableDates_SosWimmelbildImpl_Fragment
  & CmTeasableTeaserIcon_SosWimmelbildImpl_Fragment
  & CmTeasableLayout_SosWimmelbildImpl_Fragment
  & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
);

export type CmTeasable_ViewTypeHeroCollection_Fragment = (
  { __typename?: 'ViewTypeHeroCollection' }
  & CmTeasableCommon_ViewTypeHeroCollection_Fragment
  & CmTeasableDates_ViewTypeHeroCollection_Fragment
  & CmTeasableTeaserIcon_ViewTypeHeroCollection_Fragment
  & CmTeasableLayout_ViewTypeHeroCollection_Fragment
  & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
);

export type CmTeasableFragment = CmTeasable_CmArticleImpl_Fragment | CmTeasable_CmAudioImpl_Fragment | CmTeasable_CmChannelImpl_Fragment | CmTeasable_CmCollectionImpl_Fragment | CmTeasable_CmDownloadImpl_Fragment | CmTeasable_CmDynamicListImpl_Fragment | CmTeasable_CmExternalLinkImpl_Fragment | CmTeasable_CmGalleryImpl_Fragment | CmTeasable_CmhtmlImpl_Fragment | CmTeasable_CmImageMapImpl_Fragment | CmTeasable_CmInteractiveImpl_Fragment | CmTeasable_CmLocTaxonomyImpl_Fragment | CmTeasable_CmMediaImpl_Fragment | CmTeasable_CmNavigationImpl_Fragment | CmTeasable_CmPersonImpl_Fragment | CmTeasable_CmPictureImpl_Fragment | CmTeasable_CmPlaceholderImpl_Fragment | CmTeasable_CmProductImpl_Fragment | CmTeasable_CmQueryListImpl_Fragment | CmTeasable_CmSelectionRulesImpl_Fragment | CmTeasable_CmSpinnerImpl_Fragment | CmTeasable_CmTaxonomyImpl_Fragment | CmTeasable_CmTeasableImpl_Fragment | CmTeasable_CmTeaserImpl_Fragment | CmTeasable_CmVideoImpl_Fragment | CmTeasable_CmVisualImpl_Fragment | CmTeasable_FormEditorImpl_Fragment | CmTeasable_SosAmountIncreaseFormImpl_Fragment | CmTeasable_SosAuthorImpl_Fragment | CmTeasable_SosChartImpl_Fragment | CmTeasable_SosContactImpl_Fragment | CmTeasable_SosDonationCardImpl_Fragment | CmTeasable_SosDonationCertificateImpl_Fragment | CmTeasable_SosDonationFormImpl_Fragment | CmTeasable_SosDonationProductImpl_Fragment | CmTeasable_SosDonationProgressImpl_Fragment | CmTeasable_SosDonationToolImpl_Fragment | CmTeasable_SosEventImpl_Fragment | CmTeasable_SosFilterTeaserImpl_Fragment | CmTeasable_SosInternalLinkImpl_Fragment | CmTeasable_SosJobTeaserImpl_Fragment | CmTeasable_SosLocationImpl_Fragment | CmTeasable_SosNewsImpl_Fragment | CmTeasable_SosNotificationImpl_Fragment | CmTeasable_SosOfferImpl_Fragment | CmTeasable_SosOrderFormImpl_Fragment | CmTeasable_SosOrganisationImpl_Fragment | CmTeasable_SosOverlayImpl_Fragment | CmTeasable_SosPressreleaseImpl_Fragment | CmTeasable_SosPublicationImpl_Fragment | CmTeasable_SosRedirectPageImpl_Fragment | CmTeasable_SosSpecialTopicCategoryImpl_Fragment | CmTeasable_SosSpecialTopicImpl_Fragment | CmTeasable_SosTeaserImpl_Fragment | CmTeasable_SosTextfragmentImpl_Fragment | CmTeasable_SosTooltipImpl_Fragment | CmTeasable_SosWimmelbildImpl_Fragment | CmTeasable_ViewTypeHeroCollection_Fragment;

export const CmTeasableFragmentDoc = gql`
    fragment CMTeasable on CMTeasable {
  ...CMTeasableCommon
  ...CMTeasableDates
  ...CMTeasableTeaserIcon
  ...CMTeasableLayout
  ...CMTeasableTeaserTarget
  ... on CMChannel {
    specialTopicTaxonomy {
      ...CMTaxonomy
    }
  }
}
    ${CmTeasableCommonFragmentDoc}
${CmTeasableDatesFragmentDoc}
${CmTeasableTeaserIconFragmentDoc}
${CmTeasableLayoutFragmentDoc}
${CmTeasableTeaserTargetFragmentDoc}
${CmTaxonomyFragmentDoc}`;